import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function Textarea(
  { label, hint, error, className, id, rows = 3, ...rest },
  ref,
) {
  const inputId = id ?? `t-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="space-y-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[11px] font-semibold text-ink-muted uppercase tracking-wider"
        >
          {label}
        </label>
      )}
      <textarea
        {...rest}
        ref={ref}
        id={inputId}
        rows={rows}
        className={cn(
          'w-full px-3 py-2 rounded-lg resize-none',
          'bg-surface-elevated border border-surface-border text-ink',
          'placeholder:text-ink-faint',
          'focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500',
          'transition-colors duration-150 leading-relaxed',
          error && 'border-loss focus:ring-loss/40 focus:border-loss',
          className,
        )}
      />
      {error ? (
        <p className="text-xs text-loss">{error}</p>
      ) : hint ? (
        <p className="text-xs text-ink-subtle">{hint}</p>
      ) : null}
    </div>
  );
});
